import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n/i18n';
import { useSchool, type ParentAccess } from './schoolApi';

export default function ParentGate({ need, children }: { need: keyof ParentAccess; children: ReactNode }) {
  const t = useT();
  const { school, loaded } = useSchool();
  if (!loaded) return <p className="muted">{t('Loading…')}</p>;
  if (school?.role !== 'PARENT' || school.access?.[need]) return <>{children}</>;
  const what = need === 'play' ? t('Practising at home is not switched on for you.')
    : need === 'edit' ? t('Changing programs and plans is not switched on for you.')
    : t('The Talk Board is not switched on for you.');
  return (
    <div className="card">
      <h2>{t('Not available')}</h2>
      <p>{what} {t('Ask {school} if you would like it.', { school: school.name })}</p>
      <Link className="btn secondary" to="/">{t('Back to Home')}</Link>
    </div>
  );
}
